<template>
	<div
		:id="uniktId"
		class="_eui-multichart"
		:class="{
			'-inaktiverad':skaVaraInaktiverad,
			'-osynlig':skaVaraOsynlig,
		}"
		:disabled="skaVaraInaktiverad"
	>

		<eui-highcharts
			:vp-options="optionsForDiagrammetSomVisas"
			@klickat-pa-highcharts="onKlickatPaHighcharts"
		></eui-highcharts>



		<!-- ##### Dialog: Ändra (settings): -->

		<eui-dialog v-cloak
			vp-dialog-id="andraInstallningar"
			vp-huvud-text="Ändra inställningar"
			:vp-bredd-med-enhet="'43rem'"
			:vp-visa-dialogen.sync="arIAndralage"
			:vp-dialog-stack="$root.dialogStack"
			:vp-dialog-config="andraDialogConfig"
			@knapp-tryckt-i-dialog="onKnappTrycktIAndraDialog"
			@avbryt-i-dialog="onAvbrytIAndraDialog"
			#default="{ validationObserverMergedState }"
		>
			<!-- <form> behövs egentligen inte, men ökar läsbarheten av koden, ger ledtrådar till autofill, lösenordshanterare och "assisted accessibility" etc: -->
			<form style="display: flex;flex-wrap: wrap;margin: -.9rem -2rem;">

				<!--<div class="_eui-form_faltgrupp">-->

				<div style="display: inline-block;padding: .9rem 2rem;width: 21rem;">

					<eui-form-radiogrupp
						vp-etikett="Typ av diagram"
						v-model="widgetSettings.ChartType"
						:vp-radiogrupp-config="$_chartTypeRadiogruppConfig"
						vp-validation-rules="required"
					></eui-form-radiogrupp>

				</div>

				<div style="display: inline-block;padding: .9rem 2rem;width: 21rem;">

					<eui-form-radiogrupp
						vp-etikett="Omfattning"
						v-model="widgetSettings.ChartPeriod"
						:vp-radiogrupp-config="$_chartPeriodRadiogruppConfig"
						vp-validation-rules="required"
					></eui-form-radiogrupp>

				</div>

				<div style="display: inline-block;padding: .9rem 2rem;width: 21rem;">

					<!--	style="margin-top: 1.8em;">-->
					<p>
						Visa serier:
					</p>

					<eui-form-kryssruta
						vp-etikett="Utfall"
						v-model="widgetSettings.ShowCurrentYear"
						vp-class="-indragen"
						vp-style="margin-top: .6em;"
					></eui-form-kryssruta>

					<eui-form-kryssruta
						vp-etikett="Föregående år"
						v-model="widgetSettings.ShowPreviousYear"
						vp-class="-indragen"
					></eui-form-kryssruta>

					<eui-form-kryssruta v-if="widgetSettings.BudgetCanExist"
						vp-etikett="Budget"
						v-model="widgetSettings.ShowBudget"
						vp-class="-indragen"
					></eui-form-kryssruta>

					<eui-form-kryssruta
						vp-etikett="Avvikelse mot föregående år"
						v-model="widgetSettings.ShowDeviationFromPreviousYear"
						vp-class="-indragen"
					></eui-form-kryssruta>

					<eui-form-kryssruta v-if="widgetSettings.BudgetCanExist"
						vp-etikett="Avvikelse mot budget"
						:vp-inaktiverad="!widgetSettings.BudgetCanExist"
						v-model="widgetSettings.ShowDeviationFromBudget"
						vp-class="-indragen"
					></eui-form-kryssruta>

				</div>

				<div style="display: inline-block;padding: .9rem 2rem;width: 21rem;" v-if="!vpForceNoLegend">

					<!--	style="margin-top: 1.8em;">-->
					<p>
						Övrigt:
					</p>

					<!--<eui-form-kryssruta
						vp-etikett="Visa diagramförklaring"
						v-model="widgetSettings.ShowLegend"
						vp-hjalptext-html="<p>En förklaring till diagrammets serier (namn och färg).</p>"
						vp-class="-indragen"
						vp-style="margin-top: .6em;"
					></eui-form-kryssruta>-->

					<eui-form-kryssruta
						vp-etikett="Dölj diagramförklaringen<br>i små diagram"
						v-model="widgetSettings.HideLegendWhenChartIsSmall"
						vp-hjalptext-html="<p>En diagramförklaring visar vad diagrammets serier representerar (namn och färg).</p>"
						vp-class="-indragen"
						vp-style="margin-top: .6em;"
					></eui-form-kryssruta>

				</div>

			</form>
		</eui-dialog>


	</div>
</template>


<script>
	// #############################################################################################################

	import Vue from 'vue';
	import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';

	import euiHighcharts from 'v-components/euiHighcharts.vue';

	// Klon av originalet på https://github.com/Kelin2025/vue-responsive-components:
	import { ResponsiveContainerMixin } from 'ResponsiveContainer';

	import euiDialogClasses from 'v-components/classes/euiDialogClasses';
	import euiFormClasses from 'v-components/classes/euiFormClasses';

	import euiDialog from 'v-components/euiDialog';
	//import euiFormTextruta from 'v-components/euiFormTextruta.vue';
	import euiFormKryssruta from 'v-components/euiFormKryssruta.vue';
	import euiFormRadiogrupp from 'v-components/euiFormRadiogrupp.vue';
	//import { euiSwitch } from 'v-components/euiSwitch';
	//import euiFormSelect from 'v-components/euiFormSelect.vue';


	//Vue.use(euiSwitch);

	// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
	let uniktIdCounter = 0;


	//------------------------------------------------------------------------------------------------------------------------------

	export default {
		name: 'eui-multichart',

		// Lokalt registrarade komponenter
		components: {
			euiHighcharts,
			euiDialog,
			euiFormRadiogrupp,
			euiFormKryssruta,
		},

		mixins: [
			euiLifecycleStatusesMixin,
			ResponsiveContainerMixin
		],

		// Det måste finnas minst en breakpoint för att vueResponsiveComponentsMixin ska skrida till verket och sätta w/h under data:
		breakpoints: { dummy() { return true }, },

		props: {
			// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpWidgetSettings', då denna komponent i sig sjäv kan komma att ändra dess värde (ändra diagraminställningar):
			vpWidgetSettings: {
				type: Object,
				required: true,
			},

			vpWidgetData: {
				type: Object,
				required: true,
			},

			vpForceNoLegend: {				// Legend override for small charts
				type: Boolean,
				default: false,
			},
			vpForceNoTitle: {				// Title override for charts in panels etc
				type: Boolean,
				default: false,
			},

			// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpArIAndralage':
			vpArIAndralage: {
				type: Boolean,
				default: false
			},

			vpInaktiverad: {
				type: Boolean,
				default: false
			},
			vpOsynlig: {
				type: Boolean,
				default: false
			},
		},

		data() {
			return {
				uniktId: 'eui-multicharts-unikt-' + (++uniktIdCounter),

				legendVisas: false,	// Utgångsläge. Sätts om i kod.

				optionsForDiagrammetSomVisas: undefined,		// Sätts i kod.

				widgetSettings: this.vpWidgetSettings,
				widgetSettingsUndansparade: undefined,		// Sätts i kod.

				//widgetSettingsBudgetOchForegUndansparade: undefined,		// Sätts i kod.

				// Obs! för denna dialog används config-membern 'visas' *inte*. Istället styrs visningen av en helt annan variabel (arIAndralage). Det är lite förvillande och ev borde 'visas' *inte* finnas som en member i config, se kommentar i euiDialogClasses.js:
				arIAndralage: this.vpArIAndralage,

				andraDialogConfig: new euiDialogClasses.dialogConfig([
					new euiDialogClasses.knappAvbryt(),
					new euiDialogClasses.knappEvent('Spara', 'sparaInstallningar', { validateBeforeEmit: true }),
				]),
			}
		},

		computed: {
			//valdChartTypeArAvvikelse() {
			//	return (this.widgetSettings.ChartType === this.$_chartTypeDeviation);
			//},

			valtDiagramKey() {
				return 'd' + this.widgetSettings.ChartType + this.widgetSettings.ChartPeriod;
			},

			diagrammetsBredd() {
				return Math.trunc(this.el.width);	// Heltal! Not (!) Math.round();
			},

			//diagrammetsHojd() {
			//	return Math.trunc(this.el.height);	// Heltal! Not (!) Math.round();
			//},

			skaVaraOsynlig() {
				return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedAndNextTickHasOccured);	//AndSecondNextTickHasOccured);
			},

			skaVaraInaktiverad() {
				return (this.vpInaktiverad);				// || !this.lifecycleStatuses.mixinMountedAndSecondNextTickHasOccured);
			},
		},

		watch: {
			vpWidgetSettings: {
				// Obs! Denna watch är "deep"!
				handler(nyttVarde, tidigareVarde)
				{
					this.widgetSettings = nyttVarde;
				},
				deep: true,
			},

			widgetSettings: {
				// Obs! Denna watch är "deep"!
				handler(nyttVarde, tidigareVarde)
				{
					// Propen används med .sync i parent component:
					this.$emit('update:vpWidgetSettings', nyttVarde);

					// Rita om diagrammet efter de nya settings:
					this.sattOptionsForDiagrammetSomVisas();
				},
				deep: true,
			},

			//-------------------

			vpArIAndralage(nyttVarde, tidigareVarde)
			{
				this.arIAndralage = nyttVarde;
			},

			arIAndralage(nyttVarde, tidigareVarde)
			{
				// Propen används med .sync i parent component:
				this.$emit('update:vpArIAndralage', nyttVarde);

				if (nyttVarde === true)
				{
					// När widgeten försätts i ändraläge:
					// Spara undan initiala värden:

					// For deep cloning, we need to use alternatives because Object.assign() copies property values. If the source value is a reference to an object, it only copies that reference value.
					//this.widgetSettingsUndansparade = Object.assign({}, this.widgetSettings);
					// Deep Clone:
					this.widgetSettingsUndansparade = JSON.parse(JSON.stringify(this.widgetSettings));
				}
			},

			//-------------------

			diagrammetsBredd(nyttVarde, tidigareVarde) {
				//console.log('Ny bredd på diagrammet: ' + tidigareVarde + ' -> ' + nyttVarde);

				this.legendVisas = this.skaLegendVisas();
			},

			legendVisas(nyttVarde, tidigareVarde) {
				//console.log('Ny status på legendVisas: ' + tidigareVarde + ' -> ' + nyttVarde);

				if (tidigareVarde !== undefined)
				{
					// Inte den initiala tilldelningen, från undefined -> X:
					this.sattOptionsForDiagrammetSomVisas();
				}
			},
		},

		methods: {
			skaLegendVisas()
			{
				// Inledningsvis = false.

				// Under dessa villkor ska legend *inte* visas:
				if (this.vpForceNoLegend
					|| this.el.width === 0
					|| (this.widgetSettings.HideLegendWhenChartIsSmall
						&& this.el.width < 400	// 500 bättre?
					)
				)
				{
					// Om legend *aldrig* ska visas
					// ELLER bredden inte hunnit sättas än (av ResponsiveContainerMixin) = diagrammet är inte skapat/utritat än
					// ELLER (legend inte ska visas om diagrammet är litet och det är så):
					return false;
				}

				// Villkor ovan inte uppfyllt:
				// Legend ska visas:
				return true;
			},

			onKlickatPaHighcharts()
			{
				// Skicka event att det klickats på diagrammet:
				this.$emit('klickat-pa-multichart');
			},

			onAvbrytIAndraDialog()
			{
				//console.log('Avbryt dialogen');

				// Återställ till undansparade värden:
				// For deep cloning, we need to use alternatives because Object.assign() copies property values. If the source value is a reference to an object, it only copies that reference value.
				//this.widgetSettings = Object.assign({}, this.widgetSettingsUndansparade);
				// Deep Clone:
				this.widgetSettings = JSON.parse(JSON.stringify(this.widgetSettingsUndansparade));

				// Av sanitära skäl:
				this.widgetSettingsUndansparade = undefined;
			},

			onKnappTrycktIAndraDialog({ eventId, eventData }) {
				switch (eventId) {
					case 'sparaInstallningar':
						{
							//console.log('Spara inställningarna');

							// När man kommer hit: Allt validerar *client-side* (*standard-valideringar*):

							// UI och dess underliggande data är redan "live" uppdaterade med rätt nya värden (via reaktivitet).
							// Obs! DENNA "LIVE" METOD FÖRUTSÄTTER antagligen att värdena i dialogen *aldrig* kan bli invalid!


							// Nej, detta ska inte göras förrän efter sparningen, alltså i anropande kod, efter hanteringen av even
							//// Stäng dialogen:
							//this.arIAndralage = false;
							//// Av sanitära skäl:
							//this.widgetSettingsUndansparade = undefined;

							// Skicka event att ändringar ska sparas:
							this.$emit('widget-settings-andrade', this.widgetSettings);

							break;
						}
				}
			},

			sattOptionsForDiagrammetSomVisas() {
				//console.log('##### sattOptionsForDiagrammetSomVisas');


				//#########################################################################################################################################
				// Det här är knutpunkten som översätter våra vpWidgetSettings till HighCharts vpOptions (för det diagram(-typ) som visas för närvarande):
				//#########################################################################################################################################



				// Grund-options (och data) för diagrammet:
				//let nyaOptions = this.vpWidgetData[this.valtDiagramKey];
				// For deep cloning, we need to use alternatives because Object.assign() copies property values. If the source value is a reference to an object, it only copies that reference value.
				//let nyaOptions = Object.assign({}, this.vpWidgetData[this.valtDiagramKey]);
				// Deep Clone:
				let nyaOptions = JSON.parse(JSON.stringify(this.vpWidgetData[this.valtDiagramKey]));

				// Applicera aktuella inställningar:

				this.legendVisas = this.skaLegendVisas();			// Denna sätts för att hantera storleksförändringar reaktivt.
				nyaOptions.legend.enabled = this.legendVisas;	//(this.vpForceNoLegend ? false : this.widgetSettings.ShowLegend);

				for (var y = nyaOptions.series.length - 1; y >= 0; y--) {
					//console.log('Updated visibility for series ' + nyaOptions.series[y].id);

					switch (nyaOptions.series[y].id)
					{
						case 'CY':
							nyaOptions.series[y].visible = this.widgetSettings.ShowCurrentYear;
							nyaOptions.series[y].showInLegend = this.widgetSettings.ShowCurrentYear;
							break;
						case 'PY':
							nyaOptions.series[y].visible = this.widgetSettings.ShowPreviousYear;
							nyaOptions.series[y].showInLegend = this.widgetSettings.ShowPreviousYear;
							break;
						case 'BU':
							nyaOptions.series[y].visible = this.widgetSettings.ShowBudget;
							nyaOptions.series[y].showInLegend = this.widgetSettings.ShowBudget;
							break;
						case 'DEVPY':
							nyaOptions.series[y].visible = this.widgetSettings.ShowDeviationFromPreviousYear;
							nyaOptions.series[y].showInLegend = this.widgetSettings.ShowDeviationFromPreviousYear;
							break;
						case 'DEVBU':
							nyaOptions.series[y].visible = this.widgetSettings.ShowDeviationFromBudget;
							nyaOptions.series[y].showInLegend = this.widgetSettings.ShowDeviationFromBudget;
							break;
					}
				}


				// Ofärdigt som övergavs: Hantera skottdag(ar) på CY/PY client side i js:
				//// Justera vid behov serier/x-axis-kategorier/tickPositions med avseende på ev skottdag(ar):
				//
				//// Blir aldrig aktuellt för 'd21' för det är ett (det enda) med månadsvärden, ist.f. dagliga värden:
				//if (this.valtDiagramKey !== 'd21')
				//{
				//	var serieCyFinns = nyaOptions.series.find(x => x.id === 'CY');
				//	var seriePyFinns = nyaOptions.series.find(x => x.id === 'PY');
				//	var serieDevPyFinns = nyaOptions.series.find(x => x.id === 'DEVPY');
				//
				//	// Dessa flaggar om serierna *verkligen* visas, inte bara om inställningarna säger att de ska visas:
				//	var serieCyVisas = serieCyFinns && this.widgetSettings.ShowCurrentYear;
				//	var seriePyVisas = seriePyFinns && this.widgetSettings.ShowPreviousYear;
				//	var serieDevPyVisas = serieDevPyFinns && this.widgetSettings.ShowDeviationFromPreviousYear;
				//
				//	// X-axis:
				//
				//	if (!serieCyVisas && !serieDevPyVisas)
				//	{
				//		// Om ingen serie visas som är CY, eller framräknat från CY:
				//
				//		if (seriePyVisas)
				//		{
				//			// Om PY visas:
				//			// Justera x-axis OCH tickPositions så den gäller för PY, inte CY:
				//
				//			var skottdagCyInfo = this.vpWidgetData[this.valtDiagramKey + 'SkottdagInfoInnevarandeAr'];
				//
				//			if (skottdagCyInfo)
				//			{
				//				// Om skottdag finns på CY:
				//
				//				// Ta bort den dagen från x-axis:
				//				nyaOptions.xAxis.categories
				//						.splice(skottdagCyInfo.SkottdagensIndexIArrayer, 1);
				//
				//				// Justera tickPositions efter ovanst ändring:
				//				let i;
				//				for (i = 0; i < nyaOptions.xAxis.tickPositions.length; i++)
				//				{
				//					if (nyaOptions.xAxis.tickPositions[i] >= skottdagCyInfo.SkottdagensIndexIArrayer)
				//						nyaOptions.xAxis.tickPositions[i]--;
				//				}
				//			}
				//		}
				//	}
				//}
				//
				//// Justera vid behov föreg år:
				//if (serieCyFinns && seriePyFinns
				//	&& this.widgetSettings.ShowPreviousYear)
				// ...


				// Bygg diagramrubriken:

				var title = this.widgetSettings.Title;  // Template (!) för title från settings.

				title = title.replace('[AccountName]', this.vpWidgetData.DefaultChartName);

				switch (this.widgetSettings.ChartPeriod)
				{
					case 1: title = title.replace('[Month]', 'helår'); break;
					case 2: title = title.replace('[Month]', this.vpWidgetData.CurrentMonthName); break;
					case 3: title = title.replace('[Month]', this.vpWidgetData.PreviousMonthName); break;
				}

				//if (this.widgetSettings.ChartType == '3') {
				//	title = title + ' – avvikelse';	// Obs! Tankstreck!!!!!!!
				//}

				// Meddela parent vad diagramrubriken blev:
				this.$emit('title-set', title);

				nyaOptions.title.text = (this.vpForceNoTitle ? '' : title);

				// Genomför bytet:
				this.optionsForDiagrammetSomVisas = nyaOptions;
			},
		},



		//== Lifecycle hooks  ================================================================================================================

		created()
		{
			// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.

			// Aktivera det valda diagrammet:
			this.sattOptionsForDiagrammetSomVisas();

			// Sätt innehåll i radiogrupper för ändra-formuläret:
			// De sätts här för de behöver inte/ska inte vara reaktiva:

			//this.$_chartTypeDeviation = 3;

			this.$_chartTypeRadiogruppConfig = new euiFormClasses.radiogruppConfig([
					new euiFormClasses.radioknapp('Stapeldiagram', 2),		// , { disabled: true }),
					new euiFormClasses.radioknapp('Linjediagram', 1),
					//new euiFormClasses.radioknapp('Avvikelsen från föregående år', this.$_chartTypeDeviation),
				]
			);

			this.$_chartPeriodRadiogruppConfig = new euiFormClasses.radiogruppConfig([
					new euiFormClasses.radioknapp('Hela året', 1),		// , { disabled: true }),
					new euiFormClasses.radioknapp('Innevarande månad', 2),
					new euiFormClasses.radioknapp('Föregående månad', 3),
				]
			);
		},

		mounted() {
			//console.log('euiMultichart mounted()');
			//console.log('   ' + this.$el.offsetWidth + ' x ' + this.$el.offsetHeight );

			//this.$nextTick(function () {
			//	// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			//	//console.log('euiMultichart mounted.$nextTick()');
			//	//console.log('   ' + this.$el.offsetWidth + ' x ' + this.$el.offsetHeight );
			//})
		}
	}

</script>
